import { combineReducers } from "redux";
import { currentSectionReducer } from "./currentPage/currentSectionReducer";
import { modalReducer } from "./modal/modalReducer";

export const uiReducer = combineReducers({
    currentSection: currentSectionReducer,
    modal: modalReducer
});
